<div class="toc-inner">
  <ul class="toc-list">
    <li *ngFor="let header of headers | async">
      <a href="{{ buildURL(header.id) }}">{{ header.innerText }}</a>
    </li>
  </ul>
</div>
